class TextCountdownTimer {
	constructor(elem, timeLeft) {
		this.timeLeft = timeLeft;
		this.elem = elem;

		this.display();
		this.start();
	}

	display() {
		this.elem.innerHTML = this.computeText();
	}

	start() {
		this.interval = setInterval(() => this.tick(), 1000);
	}

	stop() {
		clearInterval(this.interval);
	}

	tick() {
		this.timeLeft -= 1;
		this.display();

		if (this.timeLeft <= 0) {
			this.stop();
		}
	}

	computeText() {
		const diff = this.timeLeft;
		const hours = Math.ceil(diff / 3600);

		if (hours > 1) {
			return `${hours} hours`;
		}

		const minutes = Math.ceil(diff / 60);

		if (minutes > 1) {
			return `${minutes} minutes`;
		}

		if (diff === 1) {
			return "second";
		}

		return `${diff} seconds`;
	}
}

export default TextCountdownTimer;



// WEBPACK FOOTER //
// ./src/routers/Desktop/HeaderBanner/Promos/TextCountdownTimer.js